import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
const routes: RouteRecordRaw[] = [
    {
        path: '/login',
        name: '登录',
        component: () => import('../views/login/index.vue')
    },

    {
        path: '/home',
        name: '主页',
        component: () => import('../views/home/index.vue')
    },
    // {
    //     path: '/',
    //     redirect: '/home'
    // },
]



const router = createRouter({
    routes,
    history: createWebHistory(),
    scrollBehavior(to, from, savePosition) {
        return {
            behavior: 'smooth',
            top: 0,
            left: 0
        }
    }
})




export default router